import React from 'react';
import {OrbitComponent} from "../../../base-components/orbit-component/orbit-component";
import {observer} from "mobx-react";
import {HistoryDaysSelectorBox} from "./boxes/history-days-selector.box";
import {HistoryDaysSelectorOptionBox} from "./boxes/history-days-selector-option.box";
import {Check} from "@sparkware/app-utils";

interface HistoryDaysSelectorComponentProps {
    daysIntervals: number[];
    onDaysSelected: (days: number) => void;
}

export const HistoryDaysSelectorComponent = observer(
    class HistoryDaysSelectorComponent extends OrbitComponent<HistoryDaysSelectorComponentProps> {
        private _renderSelectOption(numberOfDays: number | undefined) {
            return (
                <HistoryDaysSelectorOptionBox key={numberOfDays} value={numberOfDays}>
                    {this.services.translation.translate('GAMING_HISTORY_DAYS_INTERVAL', {numberOfDays: numberOfDays})}
                </HistoryDaysSelectorOptionBox>
            )
        }

        private _onChangeHandler = (event: React.ChangeEvent<HTMLSelectElement>) => {
            const numberOfDays = parseInt(event.target?.value);
            if(Check.isNumber(numberOfDays)) {
                this.props.onDaysSelected(numberOfDays);
            }
        }
        render() {
            if(this.props.daysIntervals.length === 0) {
                return null;
            }
            return (
                <HistoryDaysSelectorBox onChange={this._onChangeHandler}>
                    {this.props.daysIntervals.map(numberOfDays => this._renderSelectOption(numberOfDays))}
                </HistoryDaysSelectorBox>
            )
        }
    }
);